import React from 'react';
import * as LucideIcons from 'lucide-react';

/**
 * Big choice tiles — used for "new vs existing", goal selection, mood.
 * Each option triggers onAction({type:'send', payload:{intent, choice}})
 */
const ChoiceChipsCard = ({ data, onAction }) => {
  const { title, options = [], intent } = data;
  return (
    <div className="space-y-3" data-testid="card-choice-chips">
      {title && <p className="text-sm text-zinc-300 font-secondary font-bold tracking-wide">{title}</p>}
      <div className="flex flex-wrap gap-2">
        {options.map(opt => {
          const Icon = opt.icon ? LucideIcons[opt.icon] : null;
          return (
            <button
              key={opt.id}
              type="button"
              className="group flex items-center gap-2 px-4 py-2.5 rounded-sm border border-zinc-700 bg-zinc-900/60 hover:border-primary hover:bg-primary/10 hover:text-primary transition-all text-sm font-secondary font-bold tracking-wide"
              onClick={() => onAction?.({ type: 'send', payload: { intent: intent || opt.id, choice: opt.id } })}
              data-testid={`choice-${opt.id}`}
            >
              {Icon && <Icon className="w-4 h-4" />}
              <span>{opt.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ChoiceChipsCard;
